import { useSelector } from "react-redux"
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { uploadFileData } from "../../services/upload-files.service";

const Scope3 = ({ month, year, facility_id, setIsMounted }) => {

    const loading = useSelector((state) => state.facilities.loading);
    const scope3Data = useSelector((state) => state.facilities.data.facilitiesdatapoint.ghg);
    const [data, setData] = useState(scope3Data);
    const [editableRowId, setEditableRowId] = useState(null);
    const [attachment, setAttachment] = useState()
    const [formDatas, setFormDatas] = useState()
    const [isloading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);

    const inputRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton =
                event.target.type === 'file' || event.target.classList.value == "fa-regular fa-pen-to-square";

            // Exclude Save and Cancel buttons from setting editableRowId to null
            if (!isActionButton && editableRowId !== null && !inputRef.current.contains(event.target)) {
                // Check if the clicked element is not the Save or Cancel button based on content
                const buttonText = event.target.classList.value.toLowerCase();
                if (buttonText != 'fa-solid fa-check' && buttonText != 'fa-solid fa-ban') {
                    setEditableRowId(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editableRowId]);

    useEffect(() => {
        setData(scope3Data);
    }, [scope3Data]);

    useEffect(() => {
        const uniqueCategories = [];
        scope3Data['Scope 3'] && scope3Data['Scope 3'].forEach((cat) => {
            if (!uniqueCategories.includes(cat.category)) {
                uniqueCategories.push(cat.category);
            }
        });
        setCategories(uniqueCategories);
    }, [scope3Data]);

    const handleEditClick = (id) => {
        setEditableRowId(id);
    };

    const handleEditDblClick = (id) => {
        setEditableRowId(id);
    };

    const handleSaveClick = async (id) => {
        data['Scope 3'] && data['Scope 3'].map((val) => {
            if (id == val.id) {
                setFormDatas({
                    data_point_id: val.id,
                    amount: val.amount ? val.amount : 0,
                    energy: val.energy ? val.energy : 0,
                    emission: val.emission ? val.emission : 0,
                    facility_id: facility_id,
                    month: month,
                    year: year,
                    attachment: attachment /*? attachment : data['Scope 3'][idx].attachment*/
                }
                );
            }
        })


        setEditableRowId(null);
    };

    useEffect(() => {
        if (formDatas) {
            setIsLoading(true)
            try {
                uploadFileData(formDatas, "facilities/datapoint").then((res) => {
                    if (res.status === 200) {
                        setIsLoading(false)
                        setFormDatas(null)
                        setAttachment(null)
                        setIsMounted(true)
                    }
                });
            } catch (error) {
                console.error(error);
            }
        }
    }, [formDatas]);

    const handleCancelClick = () => {
        setEditableRowId(null);

    };

    const formatCurrency = (value) => {
        const stringValue = value.toString();
        const parts = stringValue.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        if (parts.length === 1) {
            parts.push('00');
        } else if (parts[1].length === 1) {
            parts[1] += '0';
        }

        return parts.join('.');
    };

    const handleInputChange = (event, id, measure) => {
        const { name, value } = event.target;

        setData((prevData) => ({
            ...prevData,
            'Scope 3': prevData['Scope 3'].map((item) => {
                if (item.id === id) {
                    const updatedItem = { ...item, [name]: value };

                    // let updatedValue = isNaN(parseFloat(value)) ? 0 : value;
                    if (name === "amount" && (!isNaN(parseFloat(value)) || value == "")) {
                        const numericValue = value.replace(/[^\d.]/g, '');
                        const emission = (numericValue * measure).toFixed(2);
                        updatedItem.emission = formatCurrency(emission);

                        let values = value.replace(/[^\d.]/g, '');
                        const stringValue = values.toString();
                        const parts = stringValue.split('.');
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        updatedItem.amount = parts.join('.')
                    }

                    return updatedItem;
                }
                return item;
            }),
        }));
    };

    const handleFileChange = (event, id) => {
        const file = event.target.files[0];
        setAttachment(file)
    };

    if (isloading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }
    let displayedCategory = '';
    let displayedSubCategory = '';



    return (
        <>
            {categories.length > 0 ? (
                categories.map((cat) => {
                    const categoryData = data['Scope 3'] && data['Scope 3'].filter((item) => item.category === cat);
                    return (
                        <>
                            {categoryData.length > 0 ? (
                                categoryData.map((curData, idx) => {
                                    const { id, category, sub_title, name, unit, measure, amount, emission, attachment } = curData;

                                    return (
                                        <tr key={id}>
                                            {displayedCategory !== cat ? <td>{cat}</td> : <td>{""}</td>}
                                            {(() => { displayedCategory = cat })()}
                                            {/* <td>{cat}</td> */}
                                            {displayedSubCategory !== sub_title ? <td>{sub_title}</td> : <td>{""}</td>}
                                            {(() => { displayedSubCategory = sub_title })()}
                                            {/* <td>{sub_title}</td> */}
                                            {/* <td>{name || "--"}</td> */}
                                            <td>{name || "--"}</td>
                                            <td className="clickable" onDoubleClick={() => handleEditDblClick(id)} disabled={editableRowId !== null}>
                                                {editableRowId === id ? (
                                                    <input
                                                        ref={inputRef}
                                                        type="text"
                                                        name="amount"
                                                        value={amount}
                                                        onChange={(e) => handleInputChange(e, id, measure)}
                                                    />
                                                ) : (
                                                    <span title="Double click to edit">{amount}</span>
                                                )}
                                            </td>
                                            <td>{unit}</td>
                                            <td>{emission}</td>
                                            <td>
                                                {editableRowId === id ? (
                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                        onChange={(e) => handleFileChange(e, id)}
                                                    />
                                                ) : (
                                                    <span>
                                                        <i className="fa-solid fa-paperclip"></i>
                                                        {attachment ? (
                                                            <a href={attachment} target="_blank" rel="noopener noreferrer">
                                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                            </a>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                {editableRowId === id ? (
                                                    <>
                                                        <button className="custom-button" onClick={() => handleSaveClick(id)}><i className="fa-solid fa-check"></i></button>
                                                        <button className="custom-button" onClick={handleCancelClick}><i className="fa-solid fa-ban"></i></button>
                                                    </>
                                                ) : (
                                                    <button className="custom-button" onClick={() => handleEditClick(id)} disabled={editableRowId !== null}><span><i className="fa-regular fa-pen-to-square"></i></span></button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr key={`no-data-${cat}`}>
                                    <td colSpan="9">No data available for {cat}.</td>
                                </tr>
                            )}
                        </>
                    );
                })
            ) : (
                <tr>
                    <td colSpan="9">No categories available.</td>
                </tr>
            )}
        </>
    );

}

export default Scope3;